<template>
    <b-row class="justify-content-md-center">
      <b-col md="2" v-for="epp in elementos_proteccion" :key="epp.id">
        <b v-text="epp.name"></b>
        <b-col v-for="icon in epp.icons" :key="icon.id" class="d-flex">
          <img class="navbar-brand-minimized"
               :src="'/img/Epps/' + icon.image"
               width="46"
               height="46"
               :alt="icon.name"
          />
          <input type="checkbox"
                 style="width:27px;height:27px;"
                 :value="icon.id"
                 v-model="selectedElementosProteccion.elementos_proteccion"
                 @change="handleIcons(icon, epp.icons)"
                 :name="icon.name"
          />
        </b-col>
      </b-col>
  </b-row>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";

export default {
  name: "ModalElementosProteccion",
  async created() {
    let id_empresa = await this.obtenerIdEmpresaUsuario();
    await this.setIdEmpresaFdsProducto(id_empresa);
    if (this.$route.params.id_fds_producto !== undefined) {
      this.setIdFdsProducto(this.$route.params.id_fds_producto);
    }
    await this.getEppIconos();
  },
  methods: {
    async handleIcons(icon, availables) {
      let icons = availables.map((icon_available) => { return icon_available.id });
      await this.selectedElementosProteccion.elementos_proteccion.forEach((selected, index) => {
        if (icon.id !== selected && icons.includes(selected)) {
          this.selectedElementosProteccion.elementos_proteccion.splice(index, 1);
        }
      });
    },
    ...mapMutations('fds_productos', [
      'setIdEmpresaFdsProducto',
      'setIdFdsProducto',
      'resetSelectedElementosProteccion',
    ]),
    ...mapActions('dashboard', [
      'obtenerIdEmpresaUsuario',
    ]),
    ...mapActions('fds_productos', [
      'getEppIconos',
      'getElementosProteccion',
    ])
  },
  computed: {
    ...mapState('fds_productos', [
      'selectedElementosProteccion',
      'id_empresa',
      'id_fds_producto',
      'elementos_proteccion',
    ])
  }
}
</script>

<style scoped>

</style>
